/**
 * BJAF footer. Mobile accordion for link columns (.bjaf-footer__links--acc).
 * Desktop: headings are static. Mobile: tap heading to expand/collapse.
 */
(function () {
  function mq() {
    return window.matchMedia('(max-width: 640px)');
  }

  function closeAll(except) {
    document.querySelectorAll('.bjaf-footer__links--acc.is-open').forEach(function (col) {
      if (col === except) return;
      col.classList.remove('is-open');
      var btn = col.querySelector('.bjaf-footer__acc-btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function onClick(event) {
    var btn = event.target.closest('.bjaf-footer__acc-btn');
    if (!btn || !mq().matches) return;

    var col = btn.closest('.bjaf-footer__links--acc');
    if (!col) return;

    event.preventDefault();
    var open = col.classList.contains('is-open');
    closeAll(open ? null : col);
    col.classList.toggle('is-open', !open);
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
  }

  function syncAccordionState() {
    var mobile = mq().matches;
    document.querySelectorAll('.bjaf-footer__links--acc').forEach(function (col) {
      var btn = col.querySelector('.bjaf-footer__acc-btn');
      if (!mobile) col.classList.remove('is-open');
      if (btn) {
        btn.setAttribute(
          'aria-expanded',
          mobile ? String(col.classList.contains('is-open')) : 'true'
        );
      }
    });
  }

  document.addEventListener('click', onClick);
  window.addEventListener('resize', syncAccordionState);
  syncAccordionState();

  // Cookie preferences: open Shopify's consent UI.
  // window.privacyBanner is only injected once the cookie banner is enabled in
  // Settings > Customer privacy. Until then Shopify ships no consent UI at all
  // and the consent-tracking-api exposes getters/setters only, so the link
  // falls through to the privacy policy.
  function openCookiePrefs() {
    var banner = window.privacyBanner;
    if (banner) {
      if (typeof banner.showPreferences === 'function') {
        banner.showPreferences();
        return true;
      }
      if (typeof banner.loadBanner === 'function') {
        banner.loadBanner();
        return true;
      }
    }

    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy) {
      if (typeof privacy.showPreferences === 'function') {
        privacy.showPreferences();
        return true;
      }
      if (typeof privacy.showBanner === 'function') {
        privacy.showBanner();
        return true;
      }
    }

    var el =
      document.querySelector('#shopify-pc__banner') ||
      document.querySelector('.shopify-pc__banner__dialog');
    if (el) {
      if (typeof el.show === 'function') {
        el.show();
        return true;
      }
      el.hidden = false;
      el.style.display = '';
      return true;
    }
    return false;
  }

  function ensurePrivacyApi(done) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      done();
      return;
    }
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      done();
      return;
    }
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function () {
        done();
      }
    );
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-bjaf-cookie-prefs]');
    if (!link) return;
    event.preventDefault();
    ensurePrivacyApi(function () {
      if (!openCookiePrefs()) {
        // Last resort: privacy policy page.
        window.location.href = '/policies/privacy-policy';
      }
    });
  });
})();
